import React from 'react';
import capitalize from 'lodash/capitalize';
import DropDown from '../../../DropDown/DropDown';
import { twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';
import { postAnalyticsEvent } from '../../../../analytics/common';
import {
  CancelOptionsPage,
  Title,
  BlueSection,
  OrderLabel,
  InternalNoteContainer,
  InternalNoteInput,
  CancelOptionOneHeader,
  CancelOptionFlexItem,
  CancelButtonRow,
  SubmitButton,
  BackButton,
  DescriptionContainer,
  BlueSectionHalf,
  ReasonError,
} from './MockCancelOrRefundComponent.styles';
// legacy styling @ './ShopifyCancelOrderComponent.css';

class MockCancelOrRefundComponent extends React.Component {
  state = {
    selectedReason: 'Reason',
    internalNote: '',
    reasonError: false,
  };

  descriptions = {
    CANCEL_DESCRIPTION: 'You are authorized to cancel this order. Please provide a reason for the cancellation.',
    REFUND_DESCRIPTION:
      'You are authorized to refund this order. Please provide a reason for the refund. The customer will be receiving their refund in 3-6 business days',
  };

  goBack = () => {
    this.props.setPageState('policy');
  };

  onReasonChange = (dropDownData) => {
    const idAndValue = this.props.dropdownItems.find((item) => item.id === dropDownData);
    this.setState({
      selectedReason: idAndValue,
      reasonError: false,
    });
  };

  onNoteChange = (internalNote) => {
    this.setState({ internalNote });
  };

  cancelOrRefundOrder = (actionVerb) => {
    const {
      updateTicketFields,
      zendeskDomain,
      selectedTicket,
      expertId,
      zendeskCancelDropdownId,
      zendeskRefundDropdownId,
    } = this.props;

    if (actionVerb === 'cancel') {
      const updatedTags = {
        value: this.state.selectedReason.id,
        id: zendeskCancelDropdownId,
      };
      updateTicketFields(zendeskDomain, selectedTicket, updatedTags);
      this.props.setPageState('issued');
      const parsePointers = {
        conversationPtr: selectedTicket.ticketId,
        simplrExpertPtr: expertId,
      };
      const params = {
        internalNote: this.state.internalNote,
        selectedTag: this.state.selectedReason.id,
      };
      postAnalyticsEvent('CANCEL_TAG_ISSUED', parsePointers, params);
    } else if (actionVerb === 'refund') {
      const updatedTags = {
        value: this.state.selectedReason.id,
        id: zendeskRefundDropdownId,
      };
      updateTicketFields(zendeskDomain, selectedTicket, updatedTags);
      this.props.setPageState('issued');
      this.props.setPageState('issued');
      const parsePointers = {
        conversationPtr: selectedTicket.ticketId,
        simplrExpertPtr: expertId,
      };
      const params = {
        internalNote: this.state.internalNote,
        selectedTag: this.state.selectedReason.id,
      };
      postAnalyticsEvent('REFUND_TAG_ISSUED', parsePointers, params);
    }
  };

  handleCancelClick = () => {
    let actionVerb = this.props.selectedTask === 'cancelOrder' ? 'cancel' : 'refund';
    // Check that expert has selected a reason. If not, show error
    if (this.state.selectedReason === 'Reason') {
      this.setState({ reasonError: true });

      return;
    }

    twoBtnPopupCreator({
      content: {
        main: `Are you sure you want to ${actionVerb} the order?`,
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: `${actionVerb.toUpperCase()} ORDER`,
      },
      onConfirm: () => {
        this.cancelOrRefundOrder(actionVerb);
      },
    });
  };

  render() {
    let actionVerb = this.props.selectedTask === 'cancelOrder' ? 'cancel' : 'refund';

    return (
      <CancelOptionsPage className="shopify-cancel-page">
        <CancelOptionOneHeader>
          <Title>{capitalize(actionVerb)} Order</Title>
          <DescriptionContainer>
            {actionVerb === 'cancel' ? this.descriptions.CANCEL_DESCRIPTION : this.descriptions.REFUND_DESCRIPTION}
          </DescriptionContainer>
        </CancelOptionOneHeader>
        <CancelOptionFlexItem flexSize={2.5}>
          <BlueSection>
            <BlueSectionHalf>
              <OrderLabel>{this.props.selectedTicket.smbName.toUpperCase()} ORDER</OrderLabel>
            </BlueSectionHalf>
            <BlueSectionHalf>
              <DropDown
                label="Cancellation Reason"
                title={'Reason'}
                selected={this.state.selectedReason}
                list={this.props.dropdownItems}
                onSelectFunction={this.onReasonChange}
                insideLabel={true}
                error={this.state.reasonError}
              />
            </BlueSectionHalf>
            {this.state.reasonError && <ReasonError>Please select a reason</ReasonError>}
          </BlueSection>
          <InternalNoteContainer>
            <p>Additional notes (optional)</p>
            <InternalNoteInput
              placeholder={actionVerb === 'cancel' ? 'Add additional notes here.' : 'Add optional note here.'}
              value={this.state.internalNote}
              onChange={(e) => this.onNoteChange(e.target.value)}
            />
          </InternalNoteContainer>
        </CancelOptionFlexItem>
        <CancelButtonRow>
          <BackButton onClick={this.goBack}>BACK</BackButton>
          <SubmitButton onClick={(e) => this.handleCancelClick(e)}>{actionVerb.toUpperCase() + ' ORDER'}</SubmitButton>
        </CancelButtonRow>
      </CancelOptionsPage>
    );
  }
}

export default MockCancelOrRefundComponent;
